import http from "@seims/shared/src/services/HttpService";

var endpoint = `volunteer/scientist/`;
var lookup = `/lookup/volunteer/scientist/`
const headers = {};

const getVolunteerScientists = async ( first, max, searchText=null ) => {
    let data = [];
    if( searchText === null) {
        data = await http.get(`volunteer/scientist?&offset=${first}&limit=${max}`);
    }else {
        data = await http.get(`volunteer/scientist?&offset=${first}&limit=${max}&searchText=${searchText}`);
    }
    
//const { data } = await http.get(`volunteer/scientist?&offset=${first}&limit=${max}&searchText=${searchText}`);
  return data;
};

const getVolunteerScientist = async (id) => {
  const response = http.get(`${endpoint}${id}`, {
    headers: headers
  });
  return response;
}

const getFieldOfStudy = async () => {
  const response = await http.get(
    `${lookup}fields-of-study`
  );
  return response;
};

const getAreOfSpecialisation = async () => {
  const response = await http.get(
    `${lookup}areas-of-specialisation`
  );
  return response;
};

const getAgeRanges = async () => {
  const response = await http.get(
    `${lookup}age-ranges`
  );
  return response;
};

const getProvinces = async () => {
  const response = await http.get(
    `${lookup}locations`
  );
  return response;
};

const getLanguages = async () => {
  const response = await http.get(
    `${lookup}languages`
  );
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getVolunteerScientists,
   getVolunteerScientist,
   getFieldOfStudy,
   getAreOfSpecialisation,
   getAgeRanges,
   getProvinces,
   getLanguages
}
